import request from '../../../../setup/axios/request'

export const searchAndPaggingFolder = (data: any) => {
  return request({
    url: '/api/v1/Selling/FileManagement/search-and-pagging',
    method: 'post',
    data: data,
  })
}

export const searchAndPaggingFile = (data: any) => {
  return request({
    url: '/api/v1/FileManager/get-list-file-upload',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(data),
    },
  })
}

export const addFile = (data: any) => {
  return request({
    url: '/api/v1/Selling/FileManagement/add',
    method: 'post',
    data: data,
  })
}

export const updateFile = (data: any) => {
  return request({
    url: '/api/v1/Selling/FileManagement/update',
    method: 'post',
    data: data,
  })
}

export const deleteFile = (data: any) => {
  return request({
    url: '/api/v1/Selling/FileManagement/delete/' + data,
    method: 'delete',
  })
}
